import endpoints from '../endpoints';
import StoreFromFile from './StoreFromFile';

class CollInfoStore extends StoreFromFile {
  constructor(name) {
    super(name);
    this.storeSavedName = 'XXSCollInfoStores';
    this.endpoint = endpoints.collInfo.get;
  }
}

export default CollInfoStore;
